module.exports = __webpack_public_path__ + "static/5-707a19eb5b0ff6beb46904ed0484361b.jpg";